import React from "react";
import { Form, DatePicker, TimePicker, Popover, Icon } from "antd";
import moment from "moment";

const RefundFreighterDate = ({ form, disabled }) => {
  const { getFieldDecorator } = form;

  const popover = (
    <div className="popover-content">
      <p>
        Срок возврата фрахтовщиком ранее уплаченной в счёт оказания услуг суммы
        в случае отказа от догово- ра, если такой отказ допускается, но не более
        7 рабочих дней с момента получения фрахтовщиком де- нежных средств
        заказчика. (С3)
      </p>
    </div>
  );

  const initialValue =
    form.getFieldValue("arrivalDatetime") &&
    form.getFieldValue("arrivalDatetime").format();
  return (
    <div className="offer-card__item">
      <span className="label">
        Срок возврата фрахтовщиком
        <br /> в случае отказа от заказа (С3):
      </span>
      <Form.Item>
        {getFieldDecorator("refundFreighterDate", {
          rules: [
            {
              required: true,
              message: "Поле, обязательное для заполнения"
            }
          ],
          initialValue: moment(initialValue).add(5, "days")
        })(
          <DatePicker
            style={{ width: 128 }}
            format="DD.MM.YYYY"
            placeholder="ДД.ММ.ГГГГ"
            disabled={disabled}
            disabledDate={current =>
              current < form.getFieldValue("arrivalDatetime")
            }
          />
        )}
      </Form.Item>
      <Form.Item>
        {getFieldDecorator("refundFreighterDate", {
          initialValue: moment(initialValue)
        })(
          <TimePicker
            style={{ width: 128 }}
            defaultOpenValue={moment("00:00", "HH:mm")}
            placeholder="Время"
            format="HH:mm"
            disabled={disabled}
          />
        )}
      </Form.Item>
      <span className="extra-label additional-input">
        <span className="show-map">
          <Popover
            overlayClassName="order-popover"
            placement="topLeft"
            content={popover}
            trigger="click"
          >
            <Icon type="question-circle" />
          </Popover>
        </span>
      </span>
    </div>
  );
};

export default RefundFreighterDate;
